import script from "./NovelList.vue?vue&type=script&setup=true&lang=js"
export * from "./NovelList.vue?vue&type=script&setup=true&lang=js"

import "./NovelList.vue?vue&type=style&index=0&id=1d61c32c&lang=less&scoped=true"
import "./NovelList.vue?vue&type=style&index=1&id=1d61c32c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d61c32c"]])

export default __exports__